<template>
  <div>
    <tsoft-table
      :name="'score'"
      :api="tableApiUrl"
      :items.sync="items"
      :headerContextMenuName="'scoreTable'"
      :isNeedSearch="true"
      :isNeedCreate="false"
      :isNeedSelection="false"
      :onDataEmptyMessage="'Оценки отсутствуют'"
    />
  </div>
</template>

<script>
import { API_ORDER_SCORES } from '@/constants';
import { defaultDataItems } from '@/mixins';

export default {
  mixins: [
      defaultDataItems,
  ],  
  data() {
    return {
      tableApiUrl: API_ORDER_SCORES,
      items: {},
      isLoaded: false,
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
